const Data = requests => ({
  submit: files => {
    const fd = new FormData();
    files.forEach(file => {
      fd.append('files[]', file);
    });

    return requests.post('/data/', fd);
  },
  getMap: settings => requests.get(`/data/map/${settings}`),
  getFaults: () => requests.get('/data/fault'),
  getNearestPoi: latlng => requests.get(`/data/curve/${latlng}`),
  exportCurves: () => requests.download(`/data/curves`),
  exportMaps: () => requests.download(`/data/maps`),
});

export default Data;



// WEBPACK FOOTER //
// ./src/agent/data.js